import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
 
 
 
 
export default function ComportamentoFinanceiro({
  comportamento
}: {
  comportamento
  : any
}) {
  const { t } = useTranslation();
 
  return (
    <Panel header={t('comportamentoFinanceiro')}>
       {comportamento.columns && (
       <DataTable emptyMessage="Nenhuma informação disponível" size="small" rowGroupMode="rowspan" groupRowsBy="doc" value={comportamento.data} tableStyle={{ minWidth: '50rem' }}>
        {comportamento.columns.map((col:any) => (
                    <Column key={col.field} field={col.field} header={col.header} />
                ))}
       </DataTable>
       )}
      <p>{comportamento.message}</p>
    </Panel>
  )
}